import { PlanOffer } from '../translations-types';

const translations: PlanOffer = {
  question: 'Wil je {plan} volgend jaar voortzetten?',
  yes: 'Ja, graag',
  no: 'Nee, bedankt',
  thanksYes: 'Bedankt! Je ontvangt zo de vragenlijst per e-mail.',
  thanksNo: 'Bedankt voor je reactie.',
  alreadyRespondedYes: 'Je hebt al met "ja" gereageerd. Je ontvangt de vragenlijst per e-mail.',
  alreadyRespondedNo: 'Je hebt al met "nee" gereageerd.',
  error: 'Er is iets misgegaan. Probeer het later opnieuw.',
};

export default translations;
